// extracted by mini-css-extract-plugin
export default {"image":"C2-z","loaded":"D2-z"};